import { usePayDetails } from '../context/PayDetailsContext';

export const useEmployeeSalaryDetails = () => {
  const { compensationData } = usePayDetails();
  const {
    fixed: { totalYearlyAmount: totalYearlyFixedValue },
    variable: { totalYearlyAmount: totalYearlyVariableValue },
    otherCtc: { totalYearlyAmount: totalYearlyOtherCtcValue },
  } = compensationData.ctcBreakdownData;

  const totalAnnualCTC =
    totalYearlyFixedValue + totalYearlyOtherCtcValue + totalYearlyVariableValue;

  const basicComponent = compensationData.ctcBreakdownData.fixed.data.find(
    (component) => component.componentName.toLowerCase() === 'basic',
  );

  const totalBase = basicComponent ? basicComponent.perYearAmount : 0;

  return {
    totalAnnualCTC,
    totalBase,
  };
};
